export const DEFAULT_CRM_PROJECT_ID = "MAPP";
export const CRM_EVENT_PROJECT_PREFIX = "EVENT_CODE_";
export const REGISTRATION_DEFAULT_STANDARD_TITLE = "Buxus Registration";
export const REGISTRATION_DEFAULT_EXPRESS_TITLE = "Buxus Quick Registration";

/** Canonical slug from raw `eventCode` query value. */
export function normalizeRegistrationEventCode(rawValue: string): string {
  return rawValue
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
}

/** `project_ID_2` for CRM: `EVENT_CODE_<SLUG>` or `MAPP`. */
export function buildCrmProjectId(normalizedEventCodeSlug: string | undefined): string {
  const slug = normalizedEventCodeSlug?.trim();
  if (!slug) return DEFAULT_CRM_PROJECT_ID;
  return `${CRM_EVENT_PROJECT_PREFIX}${slug.replace(/-/g, "_")}`;
}

/** Preserve QC-prefetched project id when it differs from default. */
export function effectiveCrmProjectIdForWizard(
  stagedCrmProjectId: string | undefined,
  normalizedSessionEventCodeSlug: string | undefined,
): string {
  const current = stagedCrmProjectId?.trim();
  if (current && current !== DEFAULT_CRM_PROJECT_ID) return current;
  return buildCrmProjectId(normalizedSessionEventCodeSlug);
}
